module.exports = __webpack_public_path__ + "static/media/icon_203.ab66bfb4.svg";